import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';
import type { Picture } from 'app/typings/rooms';

export const mapPictureViewToPicture = (pic: PictureView): Picture => ({
  pictureId: pic.path,
  name: pic.name || '',
  size: pic.size ?? 0,
  dimensions: pic.dimensions,
  alt: pic.alt || '',
  credit: pic.credit,
  id: pic.id,
  updatedAt: new Date().toISOString(),
});
